import React, {useEffect, useRef, useState} from 'react';
import ReactDOM from "react-dom";
import TabChartHeader from "../../../../components/tabs/TabChartHeader";
import CalendaModalBody from "./CalendaModalBody";
import {isMobile} from "../../../../components/commonmethod/CommonMethod";

function CalendaModal({data, delayList,  modalhandler}) {

    const modalRef = useRef(null);

    const [tabAttribute, setTabAttribute] = useState([
        {clicked: true, name: "작업대기"},
        {clicked: false, name: "미처리"},
    ]);

    useEffect(() => {
        //외부 클릭시 userMenu 닫음
        function handleClickOutside(event) {
            if (modalRef.current && !modalRef.current.contains(event.target)) {
                modalhandler(false);
            }
        }
        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };

    }, [modalRef]);

    return (
        <div>
            {ReactDOM.createPortal(
                <div>
                    <div className={`calendar-modal-back`} ></div>

                    <div  className="calendar-modal" ref={modalRef}>
                    <TabChartHeader args={tabAttribute} setArgs={setTabAttribute} />
                        <table className={` large-listChart-table`}>
                        <thead className={`sticky top-0`}>
                        <tr className={``}>
                            <th className={`large-listChart-table-th w-90 mobile-hidden`}>일자</th>
                            <th className={`large-listChart-table-th w-90 mobile-hidden`}>구분</th>
                            <th className={`large-listChart-table-th w-120 `}>등록자</th>
                            <th className={`large-listChart-table-th `}>내역</th>
                            <th className={`large-listChart-table-th w-40`}>관리</th>
                        </tr>
                        </thead>
                        {tabAttribute[0].clicked && <CalendaModalBody data={data}/> }
                        {tabAttribute[1].clicked && <CalendaModalBody data={delayList}/> }

                    </table>

                </div>
                </div>
                , document.body
            )}

        </div>
    );
}

export default CalendaModal;

